var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-uploaded"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uploaded",
    clipPath: "url(#clip-uploaded)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(9.999 9.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 77.236,
    height: 77.236,
    transform: "translate(0.166 2.475)",
    fill: "#fcfcfc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_2a448184-6d78-43ce-b9dc-bd92865dfb65",
    "data-name": "2a448184-6d78-43ce-b9dc-bd92865dfb65",
    d: "M81.261,37.894v3.656A39.73,39.73,0,1,1,57.7,5.236",
    transform: "translate(-1.8 -1.794)",
    fill: "none",
    stroke: "#73bd31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "_2588aeca-dcda-4c7c-9d6b-f4843b53c82f",
    "data-name": "2588aeca-dcda-4c7c-9d6b-f4843b53c82f",
    d: "M59.749,3.6,20.019,43.37,8.1,31.449",
    transform: "translate(19.712 4.372)",
    fill: "none",
    stroke: "#73bd31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploaded);
export default __webpack_public_path__ + "static/media/uploaded.7c6c5fc810ca0e5a5683a724f569d293.svg";
export { ForwardRef as ReactComponent };